'use client';

import { useRouter } from 'next/navigation';
import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  link?: string;
  className?: string;
  onClick?: () => void;
  trackConversion?: boolean; // 👈 extra prop
}

const Button = ({
  link,
  className = '',
  children,
  onClick,
  trackConversion = false,
}: ButtonProps) => {
  const router = useRouter();

  const handleClick = () => {
    if (onClick) onClick();

    if (trackConversion && typeof window !== "undefined") {
      
      if (typeof window.gtag_report_conversion === "function") {
        // fire conversion & redirect if link exists
        window.gtag_report_conversion(link);
        return; // let gtag handle the redirect
      }
    }

    if (link) router.push(link);
  };

  return (
    <button
      onClick={handleClick}
      className={`text-white font-semibold rounded-lg shadow-md transition duration-300 ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;
